import { type BoxProps } from "@chakra-ui/react";
import React, { type ReactNode } from "react";
import { TextTitle } from "ui/text";
import { Section } from "../section";

type SimpleTextHeroProps = {
  chipText?: string;
  title: string;
  description: string;
  actions?: ReactNode;
  maxW?: BoxProps["maxW"];
};

export function SimpleTextHero({
  chipText,
  title,
  description,
  actions,
  maxW,
  ...props
}: SimpleTextHeroProps & BoxProps) {
  return (
    <Section my="biggest" mb={{ base: "biggest", md: "huge" }} {...props}>
      <TextTitle
        theme="light"
        size="lg"
        chip={chipText ? { text: chipText } : undefined}
        title={title}
        titleAs="h1"
        description={description}
        actions={actions}
        maxW={maxW}
      />
    </Section>
  );
}
